const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        render: defaultRender,
    },
    {
        title: 'Contact',
        dataIndex: 'mobile_no',
        render: defaultRender,
    },
    {
        title: "Status",
        dataIndex: "status",
        render: defaultRender,
    },
    {
        title: "Created At",
        dataIndex: "created_at",
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
    },
];

export default columns;